import Header from "./components/header"
import Footer from "./components/footer"

export default function Formula() {
    return (
        <>
        <Header />

        <div className="min-h-screen bg-gradient-to-b from-white to-yellow-50">
            {/* Hero Section */}
            <div className="relative bg-white py-16 md:py-36">
                <div className="container mx-auto px-4 md:px-8">
                    <div className="flex flex-col md:flex-row items-center justify-between gap-12">
                        {/* Product Image */}
                        <div className="md:w-1/2">
                            <img
                                src="./proDevice.png"
                                alt="iFLO Pro Bottle"
                                className="w-full max-w-lg mx-auto transform hover:scale-105 transition-transform duration-300"
                            />
                        </div>
                        
                        {/* Content */}
                        <div className="md:w-1/2 text-center md:text-left">
                            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-black">
                                PRO Formula
                            </h1>
                            <p className="text-gray-600 text-lg mb-8">
                                Professional-grade HVAC drain cleaner with advanced probiotic technology
                            </p>
                            <div className="space-y-4">
                                <a 
                                    href="https://cdn.shopify.com/s/files/1/0649/7687/9773/files/iFlo_Probiotic_HVAC_Drain_Cleaner_Professional_04182024.pdf?v=1726004261" 
                                    className="inline-flex items-center px-6 py-3 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 transition-colors duration-300"
                                >
                                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                    </svg>
                                    View SDS Sheet
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Features Section */}
            <div className="py-16 bg-white">
                <div className="container mx-auto px-4 md:px-8">
                    <h2 className="text-3xl font-bold text-center mb-12">Key Features</h2>
                    <div className="grid md:grid-cols-3 gap-8">
                        <div className="p-6 bg-yellow-50 rounded-xl hover:shadow-lg transition-shadow duration-300">
                            <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mb-4">
                                <svg className="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-2">Fast Acting</h3>
                            <p className="text-gray-600">Quickly breaks down organic matter and prevents future buildup</p>
                        </div>
                        <div className="p-6 bg-yellow-50 rounded-xl hover:shadow-lg transition-shadow duration-300">
                            <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mb-4">
                                <svg className="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-2">Safe & Eco-Friendly</h3>
                            <p className="text-gray-600">Environmentally conscious formula that's safe for your system</p>
                        </div>
                        <div className="p-6 bg-yellow-50 rounded-xl hover:shadow-lg transition-shadow duration-300">
                            <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mb-4">
                                <svg className="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-2">Long-Lasting</h3>
                            <p className="text-gray-600">Provides extended protection against future clogs</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div className="py-16 bg-yellow-50">
                <div className="container mx-auto px-4 md:px-8 text-center">
                    <h2 className="text-3xl font-bold mb-6">Ready to Experience the Difference?</h2>
                    <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
                        Join thousands of professionals who trust iFLO Pro for their HVAC maintenance needs
                    </p>
                    <a 
                        href="/signup" 
                        className="inline-flex items-center px-8 py-4 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 transition-colors duration-300 text-lg font-semibold"
                    >
                        Get Started Today
                        <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>

        <Footer />
        </>
    )
}
